import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "timer-assistant-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimerSuggestionBubble = _resolveComponent("TimerSuggestionBubble")!
  const _component_FloatingTimer = _resolveComponent("FloatingTimer")!

  return (_ctx.isUserEmployee && _ctx.userId)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showSuggestion)
          ? (_openBlock(), _createBlock(_component_TimerSuggestionBubble, {
              key: 0,
              ref: "suggestionBubble",
              message: _ctx.suggestionMessage,
              "button-text": _ctx.suggestionButtonText,
              icon: _ctx.suggestionIcon,
              onAction: _ctx.handleSuggestionAction,
              onDismiss: _ctx.dismissSuggestion
            }, null, 8, ["message", "button-text", "icon", "onAction", "onDismiss"]))
          : _createCommentVNode("", true),
        _createVNode(_component_FloatingTimer, {
          ref: "floatingTimerRef",
          "user-id": _ctx.userId
        }, null, 8, ["user-id"])
      ]))
    : _createCommentVNode("", true)
}